import { render, staticRenderFns } from "./UserMenuManagement.vue?vue&type=template&id=28ea99ba&scoped=true&"
import script from "./UserMenuManagement.vue?vue&type=script&lang=js&"
export * from "./UserMenuManagement.vue?vue&type=script&lang=js&"
import style0 from "./UserMenuManagement.vue?vue&type=style&index=0&id=28ea99ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ea99ba",
  null
  
)

export default component.exports